var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientBehavior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5301 47C26.5301 47.5523 26.0824 48 25.5301 48L9.00001 48C8.44772 48 8 47.5523 8 47L8.00009 30.4806C8.00009 29.9284 8.4478 29.4806 9.00009 29.4806L13.964 29.4806C14.5162 29.4806 14.964 29.9284 14.964 30.4806L14.964 35.0371C14.964 35.1914 14.9283 35.3435 14.8597 35.4817L14.0804 37.052C14.03 37.1536 14.1608 37.2474 14.2408 37.1671L22.6578 28.7185C23.0514 28.3233 23.6923 28.3266 24.0819 28.7258L25.6285 30.3106L27.2818 31.9351C27.6776 32.3241 27.681 32.961 27.2893 33.3542L18.9016 41.7735C18.8206 41.8547 18.9179 41.9861 19.0193 41.9324L20.401 41.1994C20.5453 41.1228 20.7062 41.0827 20.8696 41.0827H25.5301C26.0824 41.0827 26.5301 41.5305 26.5301 42.0827V47Z",
    fill: "#FF0400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4699 9.00002C15.4699 8.44773 15.9176 8.00002 16.4699 8.00002L33 8C33.5523 8 34 8.44772 34 9.00001L33.9999 25.5194C33.9999 26.0716 33.5522 26.5194 32.9999 26.5194L28.036 26.5194C27.4838 26.5194 27.036 26.0716 27.036 25.5194L27.036 20.9629C27.036 20.8086 27.0717 20.6565 27.1403 20.5183L27.9196 18.948C27.97 18.8464 27.8392 18.7526 27.7592 18.8329L19.3422 27.2815C18.9486 27.6767 18.3077 27.6734 17.9181 27.2742L16.3715 25.6894L14.7182 24.0649C14.3224 23.6759 14.319 23.039 14.7107 22.6458L23.0984 14.2265C23.1794 14.1453 23.0821 14.0139 22.9807 14.0676L21.599 14.8006C21.4547 14.8772 21.2938 14.9173 21.1304 14.9173H16.4699C15.9176 14.9173 15.4699 14.4695 15.4699 13.9173V9.00002Z",
    fill: "#FFA300"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14307_39261)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 24,
    r: 8,
    fill: "url(#paint0_linear_14307_39261)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 24,
    r: 8,
    fill: "url(#paint1_radial_14307_39261)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 24,
    r: 7.5,
    stroke: "url(#paint2_radial_14307_39261)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 24,
    r: 7.5,
    stroke: "url(#paint3_radial_14307_39261)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14307_39261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_14307_39261",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 52C51.1046 52 52.0115 51.1017 51.889 50.004C51.4384 45.9644 49.6297 42.1739 46.7279 39.2721C43.3523 35.8964 38.7739 34 34 34C29.2261 34 24.6477 35.8964 21.2721 39.2721C18.3703 42.1739 16.5616 45.9644 16.111 50.004C15.9885 51.1017 16.8954 52 18 52L34 52H50Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50 52C51.1046 52 52.0115 51.1017 51.889 50.004C51.4384 45.9644 49.6297 42.1739 46.7279 39.2721C43.3523 35.8964 38.7739 34 34 34C29.2261 34 24.6477 35.8964 21.2721 39.2721C18.3703 42.1739 16.5616 45.9644 16.111 50.004C15.9885 51.1017 16.8954 52 18 52L34 52H50Z",
    fill: "url(#paint4_linear_14307_39261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 52C51.1046 52 52.0115 51.1017 51.889 50.004C51.4384 45.9644 49.6297 42.1739 46.7279 39.2721C43.3523 35.8964 38.7739 34 34 34C29.2261 34 24.6477 35.8964 21.2721 39.2721C18.3703 42.1739 16.5616 45.9644 16.111 50.004C15.9885 51.1017 16.8954 52 18 52L34 52H50Z",
    fill: "url(#paint5_radial_14307_39261)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 52C51.1046 52 52.0115 51.1017 51.889 50.004C51.4384 45.9644 49.6297 42.1739 46.7279 39.2721C43.3523 35.8964 38.7739 34 34 34C29.2261 34 24.6477 35.8964 21.2721 39.2721C18.3703 42.1739 16.5616 45.9644 16.111 50.004C15.9885 51.1017 16.8954 52 18 52L34 52H50Z",
    stroke: "url(#paint6_radial_14307_39261)",
    strokeWidth: 2,
    mask: "url(#path-5-inside-1_14307_39261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 52C51.1046 52 52.0115 51.1017 51.889 50.004C51.4384 45.9644 49.6297 42.1739 46.7279 39.2721C43.3523 35.8964 38.7739 34 34 34C29.2261 34 24.6477 35.8964 21.2721 39.2721C18.3703 42.1739 16.5616 45.9644 16.111 50.004C15.9885 51.1017 16.8954 52 18 52L34 52H50Z",
    stroke: "url(#paint7_radial_14307_39261)",
    strokeWidth: 2,
    mask: "url(#path-5-inside-1_14307_39261)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14307_39261",
    x: 19,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14307_39261",
    x: 10.0999,
    y: 28,
    width: 47.8003,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14307_39261",
    x1: 25.5,
    y1: 15.4483,
    x2: 37.805,
    y2: 33.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14307_39261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 15.4483) scale(15 20.9655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14307_39261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22 23.4483) rotate(37.113) scale(10.9725 11.3198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14307_39261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38 14.3448) rotate(122.39) scale(6.53375 6.29094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14307_39261",
    x1: 17.125,
    y1: 32.7586,
    x2: 44.8113,
    y2: 72.3755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14307_39261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.125 32.7586) scale(33.75 47.1724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_14307_39261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.25 50.7586) rotate(37.113) scale(24.6882 25.4696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_14307_39261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.25 30.2759) rotate(122.39) scale(14.7009 14.1546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientBehavior);
export default __webpack_public_path__ + "static/media/client-behavior.dbd8e4dc1412e16e74b9ab05299486fa.svg";
export { ForwardRef as ReactComponent };